var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';



import { UserGroupList } from "./UserGroupList";
import {
deleteUserGroup,
loadUserGroups,
saveUserGroup } from "./actions/actions";

import { loadUsers } from "../../actions/actions";
import { UserGroupSidePanel } from "./UserGroupSidePanel";










const UserGroupsComponent = ({
  userGroups,
  users,
  loadUserGroups: loadGroups,
  saveUserGroup: saveGroup,
  deleteUserGroup: deleteGroup,
  loadUsers: loadAllUsers
}) => {
  const [sidePanelOpened, setSidePanelOpened] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState();
  const groupList = userGroups ? userGroups.toJS() : [];
  const userList = users ? users.toJS() : [];

  useEffect(() => {
    if (groupList.length === 0) {
      loadGroups().then();
    }
  }, []);

  function closeSidePanel() {
    setSelectedGroup(undefined);
    setSidePanelOpened(false);
  }

  const handlers = {
    handleSelect: (userGroup) => {
      setSelectedGroup(userGroup);
      setSidePanelOpened(true);
    },
    handleAddGroup: () => {
      setSelectedGroup({ name: '', members: [] });
      setSidePanelOpened(true);
    },
    handleSave: async (userGroup) => {
      if (!userGroup._id) {
        delete userGroup._id;
      }
      await saveGroup(userGroup);
      await loadAllUsers();
      closeSidePanel();
    },
    handleDelete: async (userGroup) => {
      await deleteGroup(userGroup);
      await loadAllUsers();
      closeSidePanel();
    }
  };

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(UserGroupList, {
      userGroups: groupList,
      handleSelect: handlers.handleSelect,
      handleAddGroup: handlers.handleAddGroup,
      className: sidePanelOpened ? 'with-sidepanel' : '' }),

    selectedGroup && /*#__PURE__*/
    _jsx(UserGroupSidePanel, {

      userGroup: selectedGroup,
      users: userList,
      userGroups: groupList,
      opened: sidePanelOpened,
      closePanel: closeSidePanel,
      onSave: handlers.handleSave,
      onDelete: handlers.handleDelete }, selectedGroup._id ? selectedGroup._id.toString() : '')));




};

const mapStateToProps = (state) => ({
  userGroups: state.userGroups,
  users: state.users
});

const mapDispatchToProps = {
  loadUsers,
  loadUserGroups,
  saveUserGroup,
  deleteUserGroup
};

export const UserGroups = connect(mapStateToProps, mapDispatchToProps)(UserGroupsComponent);